export const SCENARIO = 'scenario';
export const LOAN_QUOTE = 'loan-quote';
export const ME = 'me';
export const BORROWER = 'borrower';
